import { HTML_ENTITIES_UNICODE } from './constants'

export const replaceHtmlEntities = (text: string): string => {
	let textWithoutEntities = text
	HTML_ENTITIES_UNICODE.forEach(({ entity, character }) => {
		const entityRegExp = new RegExp(entity, 'g')
		textWithoutEntities = textWithoutEntities.replace(entityRegExp, character)
	})
	return textWithoutEntities
}
